$(document).ready(function(){
  console.log("cart form interactions script initialized ...")
  var FormButton = $('#checkout')
  FormButton.attr('disabled', 'disabled');
  // gestisco gli eventi sul checkbox privacy:
  $(function() {
    $('#conditions').click(function() {
      if ($(this).is(':checked')) {
        FormButton.removeAttr('disabled');
      } else {
        FormButton.attr('disabled', 'disabled');
      }
    });
  });
});
